import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { services } from '../../mock';
import { Wallet, ShieldCheck, TrendingUp, ArrowRight, Check } from 'lucide-react';

const iconMap = { Wallet, ShieldCheck, TrendingUp };

export default function ServicesSection() {
  const [flipped, setFlipped] = useState(null);
  return (
    <section id="services" className="relative py-16 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 border border-emerald-100 text-xs font-semibold text-emerald-700 uppercase tracking-wider mb-4">Our Services</div>
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl text-slate-900 font-bold">Compare Products, Not Ads</h2>
          <p className="mt-4 text-slate-600">Editor-vetted comparisons across three categories — loans, protection, and building. See what fits your goals before you apply.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc, idx) => {
            const Icon = iconMap[svc.icon];
            const isFlipped = flipped === svc.id;
            return (
              <div
                key={svc.id}
                onClick={() => setFlipped(isFlipped ? null : svc.id)}
                className={`flip-card h-[420px] sm:h-[440px] relative fadeInUp cursor-pointer ${isFlipped ? 'flipped' : ''}`}
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="flip-inner w-full h-full">
                  {/* Front */}
                  <div className="flip-face rounded-2xl bg-white border border-slate-200 p-7 shadow-sm hover:shadow-lg transition-shadow overflow-hidden flex flex-col">
                    <div className="absolute top-0 right-0 w-40 h-40 bg-emerald-50 rounded-full -mr-16 -mt-16" />
                    <div className="relative flex-1">
                      <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-md">
                        <Icon className="w-7 h-7 text-white" />
                      </div>
                      <h3 className="mt-6 font-serif-display text-2xl font-bold text-slate-900">{svc.title}</h3>
                      <p className="mt-3 text-slate-600 leading-relaxed">{svc.desc}</p>
                    </div>
                    <div className="relative flex items-center gap-2 text-emerald-700 font-semibold text-sm pt-4 mt-4 border-t border-slate-100">
                      <span className="hidden md:inline">Hover</span><span className="md:hidden">Tap</span> to learn more <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                  {/* Back */}
                  <div className="flip-face flip-back rounded-2xl bg-gradient-to-br from-slate-900 to-slate-800 text-white p-7">
                    <h3 className="font-serif-display text-2xl font-bold">{svc.title}</h3>
                    <ul className="mt-5 space-y-2.5">
                      {svc.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-2 text-sm text-slate-200">
                          <Check className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                    <Link to={svc.to} className="absolute bottom-7 left-7 right-7">
                      <div className="w-full rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white py-2.5 text-center font-semibold text-sm inline-flex items-center justify-center gap-2 transition-colors">
                        {svc.cta} <ArrowRight className="w-4 h-4" />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <Link to="/loan" className="inline-flex items-center gap-2 text-emerald-700 hover:text-emerald-800 font-semibold">
            Start Comparing Now <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
